import Pizzicato from 'pizzicato';
import * as actionTypes from './actionTypes';

export const setAudios = (audios) => {
    return {
        type: actionTypes.SET_AUDIOS,
        audios: audios
    }
}

const addDefaultEffects = pizzObj => {
    const distortion = new Pizzicato.Effects.Distortion({
        gain: 0
    });
    pizzObj.addEffect(distortion);

    const lowPassFilter = new Pizzicato.Effects.LowPassFilter({
        frequency: 22050,
        peak: 10
    });
    pizzObj.addEffect(lowPassFilter);

    const pingPongDelay = new Pizzicato.Effects.PingPongDelay({
        feedback: 0.6,
        time: 0.3,
        mix: 0
    });
    pizzObj.addEffect(pingPongDelay);


    return pizzObj;
}

export const onChangeDistortionEffect = (audioIndex, value) => {
    return {
        type: actionTypes.UPDATE_DISTORTION,
        value: value,
        index: audioIndex
    }
}

export const onChangeFrequencyEffect = (audioIndex, value) => {
    return {
        type: actionTypes.UPDATE_FREQUENCY,
        value: value,
        index: audioIndex
    }

}

export const onChangePingPongDelayEffect = (audioIndex, value) => {
    return {
        type: actionTypes.UPDATE_DELAY_MIX,
        value: value,
        index: audioIndex
    }

}

export const updateDistortionEffect = (audioIndex, updatedValue, pizzAudio) => {

}

export const initAudios = (audios, effects) => {

    return dispatch => {

        dispatch(loadingStart());
        let updatedAudios = {...audios};
        let audio1 = {...updatedAudios[0]};
        let audio2 = {...updatedAudios[1]};

        if (audio1.audioRef && audio1.audioRef.current && audio2.audioRef && audio2.audioRef.current) {
            let audioElement = audio1.audioRef.current;
            let newPizzicatoAudio1 = new Pizzicato.Sound({
                source: 'file',
                options: {
                    path: audioElement.src
                }
            }, () => {
                newPizzicatoAudio1 = addDefaultEffects(newPizzicatoAudio1);

                let analyser1 = Pizzicato.context.createAnalyser();
                newPizzicatoAudio1.connect(analyser1);
                audio1.pizzicatoAudio = newPizzicatoAudio1
                audio1.analyser = analyser1;
                audio1.context = newPizzicatoAudio1.fadeNode.context;
                audio1.progressBarPosition = audio1.context.currentTime;
                audio1.dataArray = new Uint8Array(analyser1.frequencyBinCount);
                let dur = audio1.audioRef.current.duration.toString().split('.')[0];
                let min = parseInt(dur / 60);
                let sec = dur % 60 + "";
                sec = sec.padStart(2, '0');
                let durationInMinutesSeconds = min && sec ? min + ":" + sec : '00:00';
                audio1.duration = durationInMinutesSeconds;
                audio1.progressBarPosition = 0;
                audio1.audioLength = parseInt(dur);
                updatedAudios[0] = audio1;

                let audioElement = audio2.audioRef.current;
                let newPizzicatoAudio2 = new Pizzicato.Sound({
                    source: 'file',
                    options: {
                        path: audioElement.src
                    }
                }, () => {
                    newPizzicatoAudio2 = addDefaultEffects(newPizzicatoAudio2);

                    let analyser2 = Pizzicato.context.createAnalyser();
                    newPizzicatoAudio2.connect(analyser2);
                    audio2.pizzicatoAudio = newPizzicatoAudio2
                    audio2.context = newPizzicatoAudio2.fadeNode.context;
                    audio2.progressBarPosition = audio2.context.currentTime;
                    audio2.analyser = analyser2;
                    audio2.dataArray = new Uint8Array(analyser2.frequencyBinCount);
                    let dur = audio2.audioRef.current.duration.toString().split('.')[0];
                    let min = parseInt(dur / 60);
                    let sec = dur % 60 + "";
                    sec = sec.padStart(2, '0');
                    let durationInMinutesSeconds = min && sec ? min + ":" + sec : '00:00';
                    audio2.duration = durationInMinutesSeconds;
                    audio2.progressBarPosition = 0;
                    audio2.audioLength = parseInt(dur);
                    updatedAudios[1] = audio2;

                    dispatch(setAudios(updatedAudios));
                    initEffects(effects, dispatch);
                    dispatch(loadingDone());

                });
            })
        }
    }
}

export const initEffects = (effects, dispatch) => {
    let i;
    for (i = 0; i < effects.length; i++) {
        const effectObj = effects[i];
        if (effectObj && effectObj.effectRef && effectObj.effectRef.current) {
            let audioElement = effectObj.effectRef.current;
            let pizzSound = new Pizzicato.Sound({
                source: 'file',
                options: {
                    path: audioElement.src
                }
            })
            effectObj.pizzicatoAudio = pizzSound
        }
    }
    dispatch(updateSoundEffects(effects));
}

export const updateSoundEffects = (effects) => {
    return {
        type: actionTypes.SET_SOUND_EFFECTS,
        effects: effects
    }
}

export const loadingStart = () => {
    return {
        type: actionTypes.LOADING_START
    }
}

export const loadingDone = () => {
    return {
        type: actionTypes.LOADING_DONE
    }
}

export const updateVolume = (value, index) => {
    return {
        type: actionTypes.UPDATE_VOLUME,
        volume_value: value,
        index: index
    }
}

export const playAudio = (index, pos, audioLength) => {
    return dispatch => {
        let i = pos;
        let intervalId = setInterval(() => {
            if (i >= audioLength) {
                clearInterval(intervalId);
                dispatch(stoppingAudio(index));
            } else {
                dispatch(progressBarIncrement(index, ++i));
            }
        }, 1000);
        dispatch(startPlaying(index, pos, intervalId));
    }

}

export const startPlaying = (index, pos, intervalId) => {
    return {
        type: actionTypes.PLAY_AUDIO,
        index: index,
        pos: pos,
        intervalId: intervalId
    }
}

export const progressBarChangeHandler = (value, index, intervalId, audioLength, playingStatus) => {
    return dispatch => {
        if (playingStatus === "PAUSED" || playingStatus === "STOPPED") {
            dispatch(pausingAudio(index, value));
        } else {
            dispatch(progressBarIncrement(index, value));
            clearInterval(intervalId);
            let i = value;
            let newIntervalId = setInterval(() => {
                if (i >= audioLength) {
                    dispatch(stoppingAudio(index));
                    clearInterval(newIntervalId);
                } else {
                    dispatch(progressBarIncrement(index, ++i));
                }
            }, 1000);
            dispatch(startPlaying(index, value, newIntervalId));
        }
    }
}

export const progressBarIncrement = (audioIndex, value) => {
    return {
        type: actionTypes.PROGRESSBAR_INCREMENT,
        value: value,
        index: audioIndex
    }
}
export const stopAudio = (index, intervalId) => {
    return dispatch => {
        dispatch(stoppingAudio(index));
        clearInterval(intervalId);
    }
}
export const stoppingAudio = (index) => {
    return {
        type: actionTypes.STOP_AUDIO,
        index: index
    }
}
export const pauseAudio = (index, pos, intervalId) => {
    return dispatch => {
        clearInterval(intervalId);
        dispatch(pausingAudio(index, pos));
    }
}

export const pausingAudio = (index, pos) => {
    return {
        type: actionTypes.PAUSE_AUDIO,
        index: index,
        pos: pos
    }
}

export const pannerChangeHandler = (value) => {
    return {
        type: actionTypes.CHANGE_PANNER,
        value: value
    }
}

export const setChangedAudio = (index, newFile, name, newPizzicatoAudio) => {
    return {
        type: actionTypes.AUDIO_CHANGE,
        audioIndex: index,
        newFile: newFile,
        name: name,
        pizzicatoAudio: newPizzicatoAudio
    }
}

export const audioChangeHandler = (e, audio) => {

    return dispatch => {
        dispatch(loadingStart());
        const audioFile = e.target.files[0];
        const file = URL.createObjectURL(audioFile);
        const name = audioFile.name.split(".")[0];
        const newAudio = {...audio};
        if (file) {
            newAudio.pizzicatoAudio.stop();
            let newPizzicatoAudio = new Pizzicato.Sound({
                source: 'file',
                options: {
                    path: file
                }
            }, () => {
                newPizzicatoAudio = addDefaultEffects(newPizzicatoAudio);
                dispatch(setChangedAudio(newAudio.id, file, name, newPizzicatoAudio))
                dispatch(loadingDone());
            })
        }
    }
}

export const metaDataLoadedHandler = (e, audioIndex) => {
    let duration = e.target.duration;
    let dur = duration.toString().split('.')[0];
    let min = parseInt(dur / 60);
    let sec = dur % 60 + "";
    sec = sec.padStart(2, '0');
    let durationInMinutesSeconds = min && sec ? min + ":" + sec : '00:00';

    return {
        type: actionTypes.DURATION_CHANGE,
        newDuration: durationInMinutesSeconds,
        audioIndex: audioIndex,
        audioLength: parseInt(dur)
    }
}

export const onPlayEffect = (effectIndex) => {
    return dispatch => {
        dispatch(startPlayingEffect(effectIndex));
        setTimeout(()=>{
            dispatch(stopPlayingEffect(effectIndex));
        },4000)
    }
}

export const startPlayingEffect = (effectIndex) => {
    return {
        type: actionTypes.PLAY_SOUND_EFFECT,
        index: effectIndex
    }
}

export const stopPlayingEffect = (effectIndex) => {
    return {
        type: actionTypes.STOP_SOUND_EFFECT,
        index: effectIndex
    }
}